<template>
  <div>
    <a-radio-group v-model:value="innerValue" :disabled="disabled" @change="onChange">
      <a-radio v-for="item in options" :key="item.valCode" :value="item.valCode">
        {{ item.valName }}
      </a-radio>
    </a-radio-group>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, watch } from "vue";
import { DictValRecord } from "@/views/system/dict/dict.interface";
import { DictService } from "@/views/system/dict/dict.service";

/**
 * 全局组件: 字典单选
 *
 * 使用方式:
 * <dict-radio-group v-model:value="formRef.dictCode" code="sex"></dict-radio-group>
 */
export default defineComponent({
  isGlobal: true,
  name: "DictRadioGroup",
  props: {
    code: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:value"],
  setup(props, { emit }) {
    const innerValue = ref<string | undefined>(undefined);
    const options = ref<DictValRecord[]>([]);

    const onChange = (evt) => {
      emit("update:value", evt.target.value);
    };

    onMounted(async () => {
      if (!props.code) {
        return;
      }
      options.value = await DictService.fetchOptionsByDictCode(props.code);
    });

    watch(
      () => props.value,
      (value) => {
        innerValue.value = value;
      },
      { immediate: true }
    );

    return {
      innerValue,
      options,
      onChange,
    };
  },
});
</script>
